import { apiFetch } from './apiClient';

export interface IncidentEventsRuleQueryResult {
  ok: boolean;
  mode: string;
  incidentId: string;
  incidentNumber?: string;
  armIncidentName?: string;
  title?: string;
  alerts: Array<Record<string, unknown>>;
  ruleQueries: Array<Record<string, unknown>>;
  query: string;
  querySource: string;
  timeRange: { fromUtc: string; toUtc: string };
  diagnostics: string[];
  columns?: string[];
  rows?: unknown[][];
  rowCount?: number;
}

function enc(v: string): string {
  return encodeURIComponent(v);
}

export async function fetchIncidentEventsRuleQuery(args: {
  incidentId: string;
  customerId?: string;
  armIncidentName?: string;
  incidentNumber?: string;
  limit?: number;
  fromUtc?: string;
  toUtc?: string;
}): Promise<IncidentEventsRuleQueryResult> {
  const qs = new URLSearchParams();
  if (args.customerId) qs.set('customerId', args.customerId);
  if (args.armIncidentName) qs.set('armIncidentName', args.armIncidentName);
  if (args.incidentNumber) qs.set('incidentNumber', args.incidentNumber);
  if (args.limit) qs.set('limit', String(args.limit));
  if (args.fromUtc) qs.set('fromUtc', args.fromUtc);
  if (args.toUtc) qs.set('toUtc', args.toUtc);
  return apiFetch<IncidentEventsRuleQueryResult>(`/incidents/${enc(args.incidentId)}/events-rule-query?${qs.toString()}`);
}

export async function runIncidentEventsRuleQuery(args: {
  incidentId: string;
  customerId?: string;
  armIncidentName?: string;
  incidentNumber?: string;
  limit?: number;
  fromUtc?: string;
  toUtc?: string;
  /** Analyst-edited query text — when set, runs this instead of the auto-built query. */
  query?: string;
}): Promise<IncidentEventsRuleQueryResult> {
  return apiFetch<IncidentEventsRuleQueryResult>(`/incidents/${enc(args.incidentId)}/events-rule-query/run`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(args),
  });
}
